import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Users, UserCheck, Clock, DollarSign, DoorOpen, AlertTriangle } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";
import BrandLogo from "@/components/BrandLogo";

const Stat = ({ label, value, icon: Icon, accent = "#00f0ff", testid }) => (
  <div data-testid={testid} className="bg-[#0a0a0a] border border-white/10 p-6 hover:border-white/30 transition-colors">
    <div className="flex items-start justify-between">
      <p className="overline">{label}</p>
      <Icon className="w-5 h-5" style={{ color: accent }} />
    </div>
    <p className="font-display text-6xl mt-3 leading-none" style={{ color: accent }}>{value}</p>
  </div>
);

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [logs, setLogs] = useState([]);

  const load = () => {
    api.get("/dashboard/stats").then((r) => setStats(r.data)).catch(() => {});
    api.get("/access-logs?limit=8").then((r) => setLogs(r.data)).catch(() => {});
  };
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);

  return (
    <div>
      <div className="flex items-start justify-between gap-4 mb-8">
        <div>
          <p className="overline text-[#00f0ff]">Command Center</p>
          <h1 className="font-display text-5xl">DASHBOARD</h1>
        </div>
        <BrandLogo size="h-12" className="hidden sm:flex opacity-90" />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <Stat testid="stat-total-members" label="Socios totales" value={stats?.total_members ?? "—"} icon={Users} />
        <Stat testid="stat-active" label="Membresías activas" value={stats?.active_members ?? "—"} icon={UserCheck} accent="#39FF14" />
        <Stat testid="stat-expiring" label="Por vencer (7d)" value={stats?.expiring_soon ?? "—"} icon={Clock} accent="#FFD60A" />
        <Stat testid="stat-expired" label="Vencidas" value={stats?.expired_members ?? "—"} icon={AlertTriangle} accent="#FF3B30" />
        <Stat testid="stat-checkins" label="Accesos hoy" value={stats?.checkins_today ?? "—"} icon={DoorOpen} />
        <Stat testid="stat-revenue" label="Ingresos del mes" value={stats ? `$${stats.revenue_month.toFixed(0)}` : "—"} icon={DollarSign} accent="#39FF14" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 bg-[#0a0a0a] border border-white/10 p-6">
          <p className="overline mb-6">Asistencia · últimos 7 días</p>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={stats?.attendance || []}>
              <CartesianGrid strokeDasharray="3 3" stroke="#1a1a1a" vertical={false} />
              <XAxis dataKey="day" stroke="#555" fontSize={12} tickLine={false} />
              <YAxis stroke="#555" fontSize={12} tickLine={false} allowDecimals={false} />
              <Tooltip contentStyle={{ background: "#000", border: "1px solid #333", borderRadius: 0, color: "#fff" }} cursor={{ fill: "#00f0ff11" }} />
              <Bar dataKey="count" fill="#00f0ff" radius={[0, 0, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="bg-[#0a0a0a] border border-white/10 p-6">
          <p className="overline mb-4">Accesos recientes</p>
          <div className="space-y-2">
            {logs.length === 0 && <p className="text-white/30 text-sm">Sin registros aún.</p>}
            {logs.map((l) => (
              <div key={l.id} className="flex items-center justify-between border-b border-white/5 py-2">
                <div className="min-w-0">
                  <p className="text-sm font-semibold truncate">{l.member_name}</p>
                  <p className="text-xs text-white/40 font-mono-logs">{new Date(l.timestamp).toLocaleTimeString()}</p>
                </div>
                <span className={`px-2 py-1 text-xs font-bold uppercase border ${l.access === "granted" ? "text-[#39FF14] border-[#39FF14]/30 bg-[#39FF14]/10" : "text-[#FF3B30] border-[#FF3B30]/30 bg-[#FF3B30]/10"}`}>
                  {l.access === "granted" ? "Acceso" : "Negado"}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
